module.exports = __webpack_public_path__ + "static/img/err.5973162.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lookShop/err.png
// module id = PU0p
// module chunks = 1